import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Dialog } from 'primeng/dialog';
import { StyleClassModule } from 'primeng/styleclass';

import { AuthService } from '@/auth/services';
import {
    AppEnvironmentBadge,
    AppLogo,
    ProfileComponent
} from '@/components';
import { AppConfigurator } from '@/layout/components/app.configurator';
import { LayoutService } from '@/layout/layout.service';
import { AppService } from '@/service/app.service';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppConfigurator, AppEnvironmentBadge, AppLogo, ProfileComponent, Dialog],
    templateUrl: './topbar.component.html'
})
export class TopbarComponent {
    items!: MenuItem[];
    profileModalOpened = false;

    constructor(
        public layoutService: LayoutService,
        public appService: AppService,
        private authService: AuthService
    ) {
    }

    toggleDarkMode(): void {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }

    logout(): void {
        this.authService.logout();
    }
}
